(() => {
  const money = (cents, format) => {
    const value = (Number(cents || 0) / 100).toFixed(2).replace(/\.00$/, "");
    return format ? format.replace(/\{\{\s*amount(?:_no_decimals)?\s*\}\}/, value) : `$${value}`;
  };

  document.querySelectorAll("[data-shark-product]").forEach((root) => {
    if (root.dataset.ready === "true") return;
    root.dataset.ready = "true";

    const product = JSON.parse(root.querySelector("[data-product-json]")?.textContent || "null");
    const form = root.querySelector("[data-product-form]");
    const mainMedia = root.querySelector("[data-main-media]");
    const zoomButton = root.querySelector("[data-zoom]");
    const price = root.querySelector("[data-price]");
    const variantInput = root.querySelector("[data-variant-id]");
    const addButton = root.querySelector("[data-add-to-cart]");
    const status = root.querySelector("[data-status]");
    const engravingInput = root.querySelector("[data-engraving-input]");
    const engravingPreviews = root.querySelectorAll("[data-engraving-preview]");

    root.querySelectorAll("[data-gallery-thumb]").forEach((thumb) => {
      thumb.addEventListener("click", () => {
        const template = thumb.querySelector("[data-media-template]");
        if (!mainMedia) return;
        mainMedia.querySelectorAll("video").forEach((video) => video.pause());
        const isVideo = thumb.dataset.mediaType === "video" || thumb.dataset.mediaType === "external_video";
        if (isVideo) {
          if (!template) return;
          mainMedia.replaceChildren(template.content.cloneNode(true));
        } else {
          const image = document.createElement("img");
          image.className = "shark__main-image";
          image.dataset.mainImage = "true";
          image.alt = thumb.dataset.imageAlt || "The Shark putter";
          image.src = thumb.dataset.imageSrc;
          image.loading = "eager";
          mainMedia.replaceChildren(image);
        }
        if (zoomButton) zoomButton.hidden = isVideo;
        root.querySelectorAll("[data-gallery-thumb]").forEach((item) => item.classList.toggle("is-active", item === thumb));
      });
    });

    const normalize = (value) => String(value || "").trim().toLowerCase();
    const selectedHand = () => root.querySelector('[data-choice-group="Handedness"] input:checked')?.value || "";
    const selectedGrip = () => root.querySelector('[data-choice-group="Grip Type"] input:checked')?.value || "";
    const findVariant = () => {
      if (!product?.variants?.length) return null;
      const engravingChoice = engravingInput?.value.trim() ? "Yes" : "No";
      return product.variants.find((variant) => {
        const values = variant.options?.length
          ? variant.options
          : [variant.option1, variant.option2, variant.option3];
        return normalize(values[0]) === normalize(selectedHand())
          && normalize(values[1]) === normalize(selectedGrip())
          && normalize(values[2]) === normalize(engravingChoice);
      }) || null;
    };

    const sync = () => {
      const variant = findVariant();
      if (!variant) {
        variantInput.value = "";
        addButton.disabled = true;
        addButton.textContent = "Selection unavailable";
        status.textContent = "This combination does not match a Shopify variant.";
        return;
      }
      variantInput.value = variant.id;
      price.textContent = money(variant.price, window.Shopify?.money_format);
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? "Add to cart" : "Sold out";
      status.textContent = "";
    };
    root.querySelectorAll('.shark__choices input').forEach((input) => input.addEventListener("change", sync));
    engravingInput?.addEventListener("input", () => {
      engravingInput.value = engravingInput.value.slice(0, 50);
      engravingPreviews.forEach((preview) => {
        preview.textContent = engravingInput.value.trim() || "Your Name Here";
      });
      sync();
    });
    sync();

    form?.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (!variantInput.value) return;
      addButton.disabled = true;
      addButton.textContent = "Adding to Cart";
      status.textContent = "";
      try {
        const engravingText = engravingInput?.value.trim() || "";
        const properties = engravingText ? { "Custom Engraving": engravingText } : {};
        const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: Number(variantInput.value), quantity: 1, properties }] })
        });
        if (!response.ok) throw new Error((await response.json()).description || "Unable to add this putter.");
        window.location.href = `${window.Shopify?.routes?.root || "/"}cart`;
      } catch (error) {
        status.textContent = error.message || "Something went wrong. Please try again.";
        sync();
      }
    });

    const lightbox = root.querySelector("[data-lightbox]");
    root.querySelector("[data-zoom]")?.addEventListener("click", () => {
      const mainImage = mainMedia?.querySelector("[data-main-image]");
      if (!mainImage || !lightbox) return;
      lightbox.querySelector("img").src = mainImage.currentSrc || mainImage.src;
      lightbox.querySelector("img").alt = mainImage.alt;
      lightbox.showModal();
    });
    root.querySelector("[data-close]")?.addEventListener("click", () => lightbox.close());
    lightbox?.addEventListener("click", (event) => { if (event.target === lightbox) lightbox.close(); });
  });
})();
